import SearchIcon from "@mui/icons-material/Search";
import { IconButton, InputAdornment, TextField } from "@mui/material";

type Props = {
	value: string;
	onChange: (value: string) => void;
};

export const TextFieldSearchFilter = ({ value, onChange }: Props) => {
	return (
		<TextField
			label="Search"
			value={value}
			onChange={(event) => {
				onChange(event?.target.value);
			}}
			slotProps={{
				htmlInput: { "data-test-id": "search-input" },
			}}
			InputProps={{
				startAdornment: (
					<InputAdornment position="start">
						<IconButton edge="start" size="small">
							<SearchIcon fontSize="small" />
						</IconButton>
					</InputAdornment>
				),
			}}
		/>
	);
};
